<template>
  <div class='con' :class='[$t("language.type"), {pd_top70: isFixedNavBar}]'>
    <TopNavbar />
    <AppMain />
    <Footer />
  </div>
</template>

<script>
import TopNavbar from '@/components/TopNavbar'
import AppMain from '@/components/AppMain'
import Footer from '@/components/Footer'
import { mapState } from 'vuex'

export default {
  name: 'Layout',
  components: { TopNavbar, AppMain, Footer },
  computed: {
    ...mapState(['isFixedNavBar']),
  },
}
</script>
